
import React from "react";

interface AgentPriceTagProps {
  pricingModel: string;
  price?: number;
}

export const AgentPriceTag: React.FC<AgentPriceTagProps> = ({ pricingModel, price }) => {
  return (
    <div className="text-3xl font-bold mb-1">
      {pricingModel === "free" ? (
        <span className="text-green-600 dark:text-green-400">Free</span>
      ) : (
        <span>${price?.toFixed(2) || "10.00"}</span>
      )}
    </div>
  );
};
